import type { TabsRootProps } from '@chakra-ui/react';
import { Tabs } from '@chakra-ui/react';
import type { UseUserAgentsOptions } from '@ui/hooks/api/useUserAgents';

import { useProfileDrawer } from '../useProfileDrawer';

export const TokenListTabs = (props: Partial<TabsRootProps>) => {
  const tokenListType = useProfileDrawer((s) => s.tokenListType);

  return (
    <Tabs.Root
      w="full"
      fitted
      value={tokenListType}
      onValueChange={(e) => {
        useProfileDrawer.getState().drawerScrollTop();
        useProfileDrawer.setState({
          // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
          tokenListType: e.value as UseUserAgentsOptions['type'],
        });
      }}
      {...props}
    >
      <Tabs.List padding={0}>
        <Tabs.Trigger value="holding">Holdings</Tabs.Trigger>
        <Tabs.Trigger value="create">Agents created</Tabs.Trigger>
      </Tabs.List>
    </Tabs.Root>
  );
};
